// extracted by mini-css-extract-plugin
export default {"productGrid":"U0-z","centerLink":"V0-z","productSection":"W0-z","item":"X0-z","ctaButton":"Y0-z"};